// @flow
import React from 'react';
import type { Categories } from 'store/modules/letters';
import LetterLikeButton from 'components/letter/LetterLikeButton';
import { fromNow } from 'lib/common';
import LetterActionButtons from '../LetterActionButtons';
import LetterMobileShare from '../LetterMobileShare/LetterMobileShare';
import './LetterHead.scss';

type Props = {
  id: string,
  title: string,
  categories: Categories,
  user: {
    username: string,
    id: string,
    thumbnail: ?string,
    short_bio: ?string,
  },
  likes: number,
  liked: boolean,
  ownLetter: boolean,
  onToggleLike: () => void,
  onAskRemove: () => void,
  date: string,
  logged: boolean,
  url: string,
  isPrivate: boolean,
  informCopy: () => void,
};

const LetterHead = ({
  id,
  title,
  date,
  categories,
  user,
  likes,
  liked,
  ownLetter,
  onToggleLike,
  onAskRemove,
  logged,
  isPrivate,
  url,
  informCopy,
}: Props) => {
  return (
    <div className="LetterHead">
      <h1>{title}</h1>
      <div className="date-and-likes">
        <div className="date">{fromNow(date)}</div>
        <div className="placeholder" />
        <LetterMobileShare
          url={url}
          title={title}
          username={user.username}
          informCopy={informCopy}
        />
        <LetterLikeButton onClick={onToggleLike} liked={liked} likes={likes} disabled={!logged} />
      </div>
      <div className="separator" />
      {ownLetter && <LetterActionButtons id={id} onAskRemove={onAskRemove} />}
    </div>
  );
};

LetterHead.Placeholder = () => (
  <div className="LetterHead placeholder">
    <div className="gray-block _title" />
    <div className="date-and-likes">
      <div className="date">
        <div className="gray-block _date" />
      </div>
      <div className="placeholder" />
    </div>
    <div className="separator" />
  </div>
);
export default LetterHead;



// WEBPACK FOOTER //
// ./src/components/letter/LetterHead/LetterHead.js